// src/components/Header.tsx

import { useAuth } from '../context/AuthContext';
import ThemeToggle from './ThemeToggle';
import UserMenu from './UserMenu';

export default function Header() {
  const { user } = useAuth(); // Gọi useAuth ở đây

  return (
    <header className="app-header glass-effect">
      <div className="logo">
        <a href="/">LAPVocab</a>
      </div>
      <div className="user-info">
        <ThemeToggle />
        {user && (
          <>
            {/* Lời chào, sẽ được ẩn trên mobile */}
            <span className="user-greeting">Hi, {user.name}</span>
            <UserMenu /> 
          </>
        )}
      </div>
    </header>
  );
}